
import React, { useEffect } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";
import useBasicGraphCard from "../../../core/hooks/useBasicGraphCard";
import Utils from "../../../core/utilities/Utils";
import "./../CompanyDashboard/CompanyDashboard.scss";


const KPIGraphCard = ({ t, graphData }) => {

  const { 
    renderMoreOptions,
    getChart,
    renderDisplayModal,
    setChartData,
		setChartOptions,
   } = useBasicGraphCard(t);

  useEffect(() => {
    setupDataForTheGraph(graphData);
  }, [graphData]);

  const setupDataForTheGraph = (g) => {
    if (g?.type === 'LINE') {
      setupLineChartData(g);
    }
  };

  const setupLineChartData = (g) => {
    const dataPoints = g?.legends?.sort((a, b) => a.order - b.order);
    const datasets = [];
    dataPoints[0]?.yvalues?.forEach((yValue, index) => {
      const color = Utils.getDecodedHexForGraphColor(getGraphColor(yValue.label));
      datasets.push({
        label: labelTostring(yValue.label),
        borderColor: color.borderColor,
        backgroundColor: '#FFF',
        data: [],
        fill: yValue.label === 'ACTUAL',
        borderDash: yValue.label === 'ACTUAL' ? [] : [5, 5],
        borderWidth: yValue.label === 'ACTUAL' ? 2 : 1.5
      });
    });
    dataPoints?.forEach(dp => {
      dp?.yvalues?.forEach(yValue => {
        const dataset = datasets?.find(ds => ds.label === labelTostring(yValue.label));
        dataset.data.push(yValue.value);
      });
    });

    const labels = [];
    dataPoints?.forEach(dp => {
      labels.push(dp.xvalue?.substring(0, 3));
    });

    const cOption = {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
          align: "start"
        },
        datalabels: {
          display:true,
          anchor: 'end',
          align: 'top',
          color: 'black',
          font: {
            size: 10
          },
          formatter: function (value, context) {
            return value;
          }
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              return ` ${tooltipItem?.dataset?.data[tooltipItem.dataIndex]} ${graphData.uom ?? ''}`;
            }
          }
        }
       
      },
      scales: {
        x: {
          grid: {
            color: 'rgba(200, 200, 200, 0.2)' // Set grid line color for X-axis
          }
        },
        y: {
          grid: {
            color: 'rgba(200, 200, 200, 0.2)' // Set grid line color for X-axis
          }
        },
      }
    };
    setChartOptions(cOption);
    setChartData({
      labels,
      datasets: datasets,
    });
  };

  const labelTostring = (label) => {
    switch (label) {
      case 'ACTUAL': return 'Actual';
      case 'TARGET': return 'Target';
      case 'RED_FLAG': return 'Red Flag';
      default: return label;
    }
  };

  const getGraphColor = (label) => {
    switch (label) {
      case 'ACTUAL': return 'BLUE';
      case 'TARGET': return 'GREEN';
      case 'RED_FLAG': return 'RED';
      default: return 'BLUE';
    }
  }

  const graphInfo = (
    <Popover id="popover-trigger-hover-focus" className="p-2">
      <div className="p-1">{graphData?.title}</div>
    </Popover>
  );

  const renderGraphIconHolder = () => {
    return (
      <div className='companyDashboard-iconBox'>
        <ul>
          <li key={`key-iconBox-2`}>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="bottom"
              overlay={graphInfo}>
              <span><BsInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            {renderMoreOptions({ graphType: graphData?.type, graphTitle: graphData?.title})}            
          </li>
        </ul>
      </div>
    );
  };

  return (
    <div className={`card Energy_Produced_card`}>
      <div className="Energy_Produced_card-header">
        <h6 className="m-0">{graphData?.title}</h6>
        {renderGraphIconHolder()}
      </div>
      <div className={`card-body pt-0`}>
        <div>{getChart(graphData?.type)}</div>
      </div>
      {renderDisplayModal('KPI_GRAPH', graphData)}
    </div>
  );
};
export default withTranslation()(KPIGraphCard);
